import { Component, Input, ViewEncapsulation, contentChildren } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CeParameterItemSecondaryDirective } from './ce-parameter-item.directive';

@Component({
    selector: 'ce-parameter-item',
    imports: [CommonModule],
    templateUrl: './ce-parameter-item.component.html',
    styleUrl: './ce-parameter-item.component.scss',
    host: {
        '[class]': '_computedClass()',
    },
    encapsulation: ViewEncapsulation.None
})
export class CeParameterItemComponent {
    @Input() orientation: 'horizontal' | 'vertical' = 'vertical';
    @Input() truncated = false;

    protected secondaryItems = contentChildren(CeParameterItemSecondaryDirective);

    _computedClass() {
        const hasChildren = this.secondaryItems().length > 0;
        const classes = ['CeParameterItem'];
        classes.push(`CeParameterItem--${this.orientation}`);
        classes.push(`CeParameterItem--${hasChildren ? 'hasChildren' : 'noChildren'}`);
        classes.push(`CeParameterItem--${this.truncated ? 'truncated' : 'notTruncated'}`);
        return classes.join(' ');
    }
}
